import { configureStore } from '@reduxjs/toolkit';
import  authSlice  from './featuers/AuthSlice';
import  sliceDept  from './featuers/sliceDept';
import { boardSlice } from './featuers/getCardDetailsSlice';
import commentSlice from './featuers/NewCommentSlice';

const store = configureStore({
  reducer: {
    auth: authSlice, 
    cards:boardSlice, 
    slice:sliceDept,
    comment: commentSlice
  },
});

export default store;
